import React from 'react';
import styled from 'styled-components';
import { getSlug } from 'utils';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import SmallRightArrow from 'images/shared/misc/SmallRightArrow';
import { SectionTitle } from 'components';
import { sortByGridOrder } from 'utils';
import EventTypesMultiCarousel from './EventTypesMultiCarousel';

const OtherEventTypes = ({ otherEventTypes, title, gridOrder }) => {
  const allEventTypes = gridOrder
    ? sortByGridOrder(otherEventTypes, gridOrder)
    : otherEventTypes.edges;
  return (
    <Wrapper>
      <SectionTitle title={title || 'Other Event Types'} />
      {allEventTypes.length > 3 ? (
        <EventTypesMultiCarousel cards={allEventTypes} />
      ) : (
        <Grid>
          {allEventTypes.map((eventType) => {
            const { title, theme, featuredImg } = eventType.node.childMarkdownRemark.frontmatter;
            const image = getImage(featuredImg.src);
            return (
              <Link to={`/event-types/${getSlug(title)}`} key={title}>
                <Card>
                  <Graphic image={image} alt={featuredImg.alt} />
                  <CardText>
                      <h3>{theme}</h3>
                    <ViewLocation>
                      View Event Type <SmallRightArrow />
                    </ViewLocation>
                  </CardText>
                </Card>
              </Link>
            );
          })}
        </Grid>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 3rem auto;
  max-width: 1200px;
  .gatsby-image-wrapper {
    max-height: 200px;
  }

  a {
    text-decoration: none;
  }
  @media screen and (min-width: 1024px) {
    margin: 6rem auto 3rem auto;
    gap: 3rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(294px, 350px));
  grid-auto-rows: minmax(268px, auto);
  grid-gap: 30px 25px;
  justify-content: center;
`;

const Card = styled.div`
  display: grid;
  grid-template-rows: 200px auto;
  gap: 0;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 3px 3px 7px rgba(189, 189, 189, 0.4);
  height: 100%;
  width: 100%;
  position: relative;
  h3 {
    font-family: adelle, serif;
    color: var(--dynamic-dark-grey);
    font-weight: 600;
    font-style: normal;
    font-size: 1.25rem;
    line-height: 1.2;
    margin: 0;
  }
  &:hover {
    box-shadow: 3px 3px 16px rgba(189, 189, 189, 0.8);
    transform: translate3d(0, -10px, 0);
    transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;
  }
`;

const CardText = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  position: relative;
  padding: 1rem 1.5rem;
  height: 100%;
`;

const Graphic = styled(GatsbyImage)`
  width: 100%;
  border-radius: 10px 10px 0 0;
`;

const ViewLocation = styled.p`
  font-family: 'proxima-nova', sans-serif;
  color: #bdbdbd;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: right;
  width: 100%;
`;

export default OtherEventTypes;
